/*
  <tt-emi>: product-page EMI widget (snippets/tt-emi.liquid).
  - Recomputes the monthly amounts whenever the selected variant changes (reads the product form's
    variant id, looks the price up in the embedded [data-tt-emi-prices] JSON).
  - Hidden when the variant costs less than data-min (paise).
  - "Buy on EMI" opens the popup; its button starts the GoKwik checkout (GoKwik's Buy Now) when present.
*/
if (!customElements.get('tt-emi')) {
	class TTEmi extends HTMLElement {
		connectedCallback() {
			try {
				this.prices = JSON.parse(this.querySelector('[data-tt-emi-prices]').textContent);
			} catch (e) {
				this.prices = {};
			}
			this.min = Number(this.dataset.min) || 0;
			this.tenures = (this.dataset.tenures || '').split(',').map(Number).filter(Boolean);
			this.dialog = this.querySelector('[data-tt-emi-dialog]');
			this.format = (paise) => {
				const rupees = Math.ceil(paise / 100);
				try {
					return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(rupees);
				} catch (e) {
					return '₹' + rupees;
				}
			};

			const open = this.querySelector('[data-tt-emi-open]');
			if (open && this.dialog) open.addEventListener('click', () => this.dialog.showModal());
			this.querySelectorAll('[data-tt-emi-close]').forEach((b) => b.addEventListener('click', () => this.dialog.close()));
			if (this.dialog) {
				this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
				const buy = this.querySelector('[data-tt-emi-buy]');
				if (buy) buy.addEventListener('click', () => this.buy());
			}

			// Variant pickers fire "change"; the theme then updates the form's variant id input.
			this.onChange = () => setTimeout(() => this.update(), 0);
			document.addEventListener('change', this.onChange);
			this.update();
		}

		disconnectedCallback() {
			document.removeEventListener('change', this.onChange);
		}

		get variantId() {
			const section = this.dataset.section;
			const input = document.querySelector(`#product-form-${section} input[name="id"], form[id*="${section}"] input[name="id"], product-form form input[name="id"]`);
			return input ? input.value : Object.keys(this.prices)[0];
		}

		update() {
			const price = this.prices[this.variantId];
			if (typeof price !== 'number') return;
			this.classList.toggle('tt-emi--hidden', price < this.min);
			const longest = Math.max(1, ...this.tenures);
			this.querySelectorAll('[data-tt-emi-monthly]').forEach((el) => {
				el.textContent = this.format(price / longest) + (el.closest('.tt-emi__headline') ? '' : '/month');
			});
			this.querySelectorAll('[data-tt-emi-amount]').forEach((el) => {
				el.textContent = this.format(price / Number(el.dataset.ttEmiAmount));
			});
			const total = this.querySelector('[data-tt-emi-total]');
			if (total) total.textContent = this.format(price);
		}

		// Start checkout for this product: GoKwik's Buy Now if it is on the page, else the theme's buy button.
		buy() {
			const gokwik = document.getElementById('gokwik-buy-now');
			this.dialog.close();
			if (gokwik && !gokwik.disabled) return gokwik.click();
			const dynamic = document.querySelector('.shopify-payment-button__button');
			if (dynamic) return dynamic.click();
			const form = document.querySelector('product-form form');
			if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}

	customElements.define('tt-emi', TTEmi);
}
